export const WORKFLOW_EVENT_MSG_MANUAL_CANDIDATE_MOVE = 'Manual candidate move';

export const WorkflowEventType = {
    RESUME_CREATED: 'resumeCreated',
    CANDIDATE_APPROVED_RESUME: 'candidateApprovedResume',
    TALENT_EXPERT_SENT_RESUME_TO_CANDIDATE: 'talentExpertSentResumeToCandidate',
    EMPLOYER_SENT_RESUME_TO_CANDIDATE: 'employerSentResumeToCandidate',
    INTERVIEW_CREATED: 'interviewCreated',
    REQUEST_FEEDBACK: 'requestFeedback',
    BLOCK_REQUEST_FEEDBACK: 'blockRequestFeedback',
    TALENT_RESUME_FOR_EMPLOYER: 'talentResumeForEmployer',
    TALENT_EXPERT_CONTACT_CANDIDATE: 'talentExpertContactCandidate',
    EMPLOYER_CONTACT_CANDIDATE: 'employerContactCandidate',
    TALENYA_BOT_CONTACT_CANDIDATE: 'talenyaBotContactCandidate',
    CONTACT_CANDIDATE: 'contactCandidate',
    CONFIRM_RESPONSE: 'confirmResponse',
    GIVE_PERSONAL_DATA_REVEAL_CONSENT: 'givePersonalDataRevealConsent',
    CANDIDATE_CAMPAIGN_CREATED: 'candidateCampaignCreated',
    MOVE_BACK_TO_QUALIFIED: 'moveBackToQualified',
};
